/**
 * Column widths, shared by the table columns and the page-level header row above the
 * collapses so the two stay in step.
 *
 * Not an even split: MIN/AVG/MAX SIZE hold a single number each, while WIDTH/HEIGHT/DEPTH
 * hold comma-separated lists ("24, 30, 36"). Giving the lists the space the single numbers
 * were wasting keeps them on one line in the common case, which matters now that the cells
 * truncate instead of wrapping.
 *
 * The total is deliberately 98% — the header's leading spacer absorbs the remainder.
 */
export const MODEL_NUMBER_COLUMN_WIDTHS = {
	modelNumber: "17%",
	width: "19%",
	height: "19%",
	depth: "19%",
	minSize: "8%",
	avgSize: "8%",
	maxSize: "8%",
} as const

/**
 * The same proportions as percentages, as plain numbers.
 *
 * The virtualized table cannot use the percentage strings above: antd only switches to
 * its virtual body when every column width is numeric. `resolveColumnWidths` turns these
 * into pixels against the measured container so both forms stay in step — change one and
 * change the other.
 */
export const MODEL_NUMBER_COLUMN_WEIGHTS = {
	modelNumber: 17,
	width: 19,
	height: 19,
	depth: 19,
	minSize: 8,
	avgSize: 8,
	maxSize: 8,
} as const
